import { useState } from 'react';
import { Star } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

const API_URL = '';

export const ReviewForm = ({ productId, onReviewAdded }) => {
  const { user, login } = useAuth();
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) {
      login();
      return;
    }

    if (rating === 0) {
      toast.error('Veuillez sélectionner une note');
      return;
    }

    if (comment.trim().length < 10) {
      toast.error('Votre avis doit contenir au moins 10 caractères');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/reviews`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          product_id: productId,
          rating,
          comment
        })
      });

      if (response.ok) {
        toast.success('Merci pour votre avis!');
        setRating(0);
        setComment('');
        if (onReviewAdded) onReviewAdded();
      } else {
        toast.error('Erreur lors de l\'envoi de votre avis');
      }
    } catch (error) {
      toast.error('Erreur lors de l\'envoi de votre avis');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-8 p-6 bg-[#F5F4F2]" data-testid="review-form">
      <h4 className="font-serif text-xl mb-4">Laisser un avis</h4>

      {/* Rating */}
      <div className="mb-4">
        <label className="text-sm text-[#6B6A68] mb-2 block">Votre note</label>
        <div className="flex gap-1">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              type="button"
              onClick={() => setRating(star)}
              onMouseEnter={() => setHoveredRating(star)}
              onMouseLeave={() => setHoveredRating(0)}
              className="p-1"
              data-testid={`rating-star-${star}`}
            >
              <Star
                size={24}
                className={
                  star <= (hoveredRating || rating)
                    ? 'text-[#D4AF37] fill-[#D4AF37]'
                    : 'text-[#E0DFDD]'
                }
              />
            </button>
          ))}
        </div>
      </div>

      {/* Comment */}
      <div className="mb-4">
        <label className="text-sm text-[#6B6A68] mb-2 block">Votre avis</label>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Partagez votre expérience avec ce produit..."
          rows={4}
          className="w-full p-3 border border-[#E0DFDD] focus:border-[#1A1514] outline-none text-sm resize-none"
          data-testid="review-comment"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="btn-primary px-6 py-3 text-sm font-medium disabled:opacity-50"
        data-testid="submit-review-btn"
      >
        {loading ? 'Envoi...' : 'Publier mon avis'}
      </button>

      {!user && (
        <p className="text-xs text-[#6B6A68] mt-3">
          Vous devez être connecté pour laisser un avis
        </p>
      )}
    </form>
  );
};
